import { c as _c } from "react/compiler-runtime";
import { useSphereDialog } from "@components/common/dialog/sphere-dialog-provider";
import { useAppDispatch } from "@store/store-helper";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { showArchiveProjectDialog } from "@utils/project-archive-utils";
import { useCallback } from "react";

/** Type of the callback returned by the custom hook */

/**
 * Custom hook that returns a function to archive or unarchive a project.
 */
export function useProjectArchiveDialog(t0) {
  const $ = _c(5);
  const {
    project
  } = t0;
  const {
    createDialog
  } = useSphereDialog();
  const dispatch = useAppDispatch();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== createDialog || $[1] !== dispatch || $[2] !== project || $[3] !== trackEvent) {
    t1 = async () => showArchiveProjectDialog({
      project,
      createDialog,
      dispatch,
      trackEvent
    });
    $[0] = createDialog;
    $[1] = dispatch;
    $[2] = project;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleDialog = t1;
  return handleDialog;
}